import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { RecommendedPrescriptionInfoService } from './recommended-prescription-info.service';

@Component({
  selector: 'app-recommended-prescription-info',
  templateUrl: './recommended-prescription-info.component.html',
  providers: [RecommendedPrescriptionInfoService]
})
export class RecommendedPrescriptionInfoComponent implements OnInit, OnChanges {
  prescriptions = [];
  @Input() public groupId: string;
  @Input() isLoadedTab: boolean;
  constructor(private prescriptionService: RecommendedPrescriptionInfoService) {
  }

  ngOnChanges() {
    if (this.isLoadedTab) {
      this.prescriptionService.getPrescriptions(this.groupId).subscribe(res => {
        if (res) {
          const data = res.json();
          this.prescriptions = data;
        }
      });
    }
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/recommended-prescription-info/recommended-prescription-info.component.ts